import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, authStore } from '../lib/api.js';
import PasswordInput from '../components/PasswordInput.jsx';
import modeloImg from '../../imagens/modelo.png';

export default function Login({ onSuccess }) {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  function set(field) {
    return (e) => setForm({ ...form, [field]: e.target.value });
  }

  async function submit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await api.login(form);
      authStore.set(res.accessToken, res.refreshToken);
      onSuccess(await api.me());
      navigate('/dashboard');
    } catch (err) {
      if (err.code === 'TRIAL_EXPIRED') {
        setError('Período de avaliação expirado. Contrate um plano para continuar.');
      } else {
        setError(err.message);
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#eef2f7]">
      <div className="flex min-h-screen flex-col lg:flex-row">
        <section className="flex w-full items-center justify-center px-6 py-10 lg:w-[45%] lg:px-10 xl:px-16">
          <div className="w-full max-w-[40rem]">
            <div className="mb-8 flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-500 via-cyan-400 to-teal-300 text-white shadow-[0_16px_32px_-18px_rgba(14,165,233,0.9)]">
                <span className="material-symbols-outlined text-[18px]">sell</span>
              </div>
              <div>
                <p className="text-[10px] font-semibold uppercase tracking-[0.28em] text-sky-700">EtiquetandoApp</p>
                <p className="text-[11px] text-slate-500">Estúdio de geração e impressão</p>
              </div>
            </div>

            <h1 className="studio-uniform-title login-hero-title font-h1 font-semibold text-slate-900">
              Boas-vindas ao Estúdio.
            </h1>

            <div className="mt-8 max-w-md rounded-[28px] border border-white/70 bg-white/90 p-7 shadow-[0_28px_80px_-40px_rgba(15,23,42,0.35)] backdrop-blur">

              <form onSubmit={submit} className="space-y-4">
                <Field label="E-mail" type="email" value={form.email} onChange={set('email')} placeholder="voce@empresa.com" autoComplete="username" />
                <Field label="Senha" type="password" value={form.password} onChange={set('password')} placeholder="••••••••" autoComplete="current-password" />
                {error && <p className="rounded-2xl border border-red-100 bg-red-50 px-4 py-3 text-[11px] text-red-700">{error}</p>}
                <button
                  type="submit"
                  disabled={busy}
                  className="w-full rounded-2xl bg-slate-900 px-4 py-3 text-[11px] font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  {busy ? 'Entrando…' : 'Continuar'}
                </button>
              </form>
            </div>

            <div className="mt-6 max-w-md flex flex-col gap-3 text-[11px] text-slate-500 sm:flex-row sm:items-center sm:justify-between">
              <p>
                Ainda não tem espaço?{' '}
                <Link to="/planos" className="font-semibold text-sky-700 transition hover:text-sky-800">
                  Criar agora
                </Link>
              </p>
            </div>

            <div className="mt-8 grid max-w-md gap-3 lg:hidden">
              <MobileFlowCard />
            </div>
          </div>
        </section>

        <section className="relative hidden flex-1 overflow-hidden bg-[linear-gradient(180deg,#dcecff_0%,#c7e4ff_46%,#9ee4f0_100%)] lg:flex">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.72),transparent_38%),radial-gradient(circle_at_bottom_right,rgba(14,165,233,0.20),transparent_30%)]" />
          <div className="absolute left-1/2 top-1/2 h-[38rem] w-[38rem] -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/35 bg-[radial-gradient(circle,rgba(255,255,255,0.40)_0%,rgba(255,255,255,0.18)_40%,rgba(255,255,255,0.04)_70%,transparent_100%)]" />
          <div className="absolute left-1/2 top-1/2 h-[28rem] w-[28rem] -translate-x-1/2 -translate-y-1/2 rounded-full border border-sky-200/60" />
          <div className="absolute left-1/2 top-1/2 h-[18rem] w-[18rem] -translate-x-1/2 -translate-y-1/2 rounded-full border border-sky-300/60" />
          <div className="absolute left-1/2 top-1/2 z-10 flex h-44 w-44 -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center rounded-full border border-white/60 bg-white/20 p-6 text-center shadow-[0_30px_60px_-32px_rgba(14,165,233,0.65)] backdrop-blur-md">
            <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-white text-sky-600 shadow-sm">
              <span className="material-symbols-outlined text-[22px]">hub</span>
            </div>
            <p className="text-[11px] font-semibold text-slate-900">Fluxo em tempo real</p>
            <p className="mt-1 text-[10px] leading-5 text-slate-600">Dados entram, etiquetas sío geradas e a impressão segue para a fila certa.</p>
          </div>

          <div className="absolute left-[13%] top-[15%] h-px w-[32%] rotate-[18deg] bg-gradient-to-r from-transparent via-sky-300 to-transparent opacity-70" />
          <div className="absolute right-[13%] top-[22%] h-px w-[26%] rotate-[-28deg] bg-gradient-to-r from-transparent via-sky-300 to-transparent opacity-70" />
          <div className="absolute left-[17%] bottom-[24%] h-px w-[30%] rotate-[-18deg] bg-gradient-to-r from-transparent via-sky-300 to-transparent opacity-70" />
          <div className="absolute right-[14%] bottom-[22%] h-px w-[26%] rotate-[20deg] bg-gradient-to-r from-transparent via-sky-300 to-transparent opacity-70" />

          <VisualCard
            className="left-[14%] top-[10%] w-[17rem]"
            eyebrow="Entrada"
            title="Dados de origem"
            icon="dataset"
            accent="sky"
          >
            <div className="space-y-2">
              <CardLine label="Pedido" value="EXP-2048" />
              <CardLine label="Cliente" value="Hospital Central" />
              <CardLine label="Lote" value="128 etiquetas" />
            </div>
          </VisualCard>

          <VisualCard
            className="right-[10%] top-[12%] w-[16.5rem]"
            eyebrow="Geração"
            title="Etiqueta pronta"
            icon="sell"
            accent="cyan"
          >
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3">
              <div className="flex items-center justify-between text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400">
                <span>Modelo ZPL</span>
                <span>4x3</span>
              </div>
              <div className="mt-3 space-y-2">
                <div className="h-2.5 w-20 rounded-full bg-slate-900" />
                <div className="h-2 w-full rounded-full bg-slate-300" />
                <div className="flex items-end justify-between">
                  <div className="space-y-1">
                    <div className="h-2 w-24 rounded-full bg-sky-400" />
                    <div className="h-2 w-16 rounded-full bg-slate-300" />
                  </div>
                  <div className="grid h-12 w-12 place-items-center rounded-lg border border-slate-300 bg-white text-slate-700">
                    <span className="material-symbols-outlined text-[20px]">qr_code_2</span>
                  </div>
                </div>
              </div>
            </div>
          </VisualCard>

          <VisualCard
            className="left-[17%] bottom-[12%] w-[18rem]"
            eyebrow="Fila"
            title="Lote em processamento"
            icon="inventory_2"
            accent="teal"
          >
            <div className="space-y-3">
              <QueueRow label="Conferência" value="100%" tone="bg-emerald-400" width="w-full" />
              <QueueRow label="Geração" value="72%" tone="bg-sky-500" width="w-[72%]" />
              <QueueRow label="Separação" value="58%" tone="bg-cyan-400" width="w-[58%]" />
            </div>
          </VisualCard>

          <VisualCard
            className="right-[5%] top-[52%] flex h-[14.5rem] w-[17rem] flex-col"
            eyebrow="impressão"
            icon="print"
            accent="sky"
          >
            <div className="flex h-full flex-col justify-between gap-2">
              <div className="flex items-start gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-2.5">
                <div className="grid h-12 w-12 place-items-center rounded-2xl bg-slate-900 text-white">
                  <span className="material-symbols-outlined text-[22px]">print_connect</span>
                </div>
                <div className="min-w-0 pt-0.5">
                  <p className="truncate text-[11px] font-semibold text-slate-900">Impressora Exp. 03</p>
                  <p className="mt-0.5 text-[10px] text-slate-500">USB + fila local sincronizada</p>
                  <div className="mt-1.5 inline-flex items-center gap-2 rounded-full bg-emerald-50 px-2.5 py-0.5 text-[10px] font-semibold text-emerald-700">
                    <span className="h-2 w-2 rounded-full bg-emerald-500" />
                    Pronta para imprimir
                  </div>
                </div>
              </div>
              <div className="flex h-24 items-center justify-center overflow-hidden rounded-2xl border border-slate-200/80 bg-white/80 p-2">
                <img
                  src={modeloImg}
                  alt="Modelo de etiqueta"
                  className="h-full w-full object-contain"
                />
              </div>
            </div>
          </VisualCard>

          <FloatingChip className="left-[20%] top-[42%]">CSV</FloatingChip>
          <FloatingChip className="left-[46%] top-[20%]">ZPL</FloatingChip>
          <FloatingChip className="right-[24%] top-[46%]">QR</FloatingChip>
          <FloatingChip className="right-[20%] top-[80%]">PDF</FloatingChip>
        </section>
      </div>
    </div>
  );
}

function Field({ label, type = 'text', ...props }) {
  const inputCls =
    'w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-[11px] text-slate-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.7)] outline-none transition placeholder:text-slate-400 focus:border-sky-400 focus:ring-4 focus:ring-sky-100';
  return (
    <label className="block">
      <span className="mb-2 block text-[11px] font-medium text-slate-700">{label}</span>
      {type === 'password' ? (
        <PasswordInput {...props} className={`${inputCls} pr-10`} />
      ) : (
        <input type={type} {...props} className={inputCls} />
      )}
    </label>
  );
}

function VisualCard({ className, eyebrow, title, icon, accent, children }) {
  const accents = {
    sky: 'from-sky-500/14 to-white',
    cyan: 'from-cyan-400/16 to-white',
    teal: 'from-teal-400/14 to-white',
  };

  return (
    <div
      className={`absolute rounded-[30px] border border-white/70 bg-gradient-to-br ${accents[accent] || accents.sky} p-5 shadow-[0_30px_60px_-34px_rgba(15,23,42,0.4)] backdrop-blur-sm ${className}`}
    >
      <div className="mb-4 flex items-start justify-between gap-4">
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-sky-700">{eyebrow}</p>
          {title ? <p className="mt-2 text-[13px] font-semibold text-slate-900">{title}</p> : null}
        </div>
        <div className="grid h-11 w-11 place-items-center rounded-2xl bg-white text-sky-700 shadow-sm">
          <span className="material-symbols-outlined text-[18px]">{icon}</span>
        </div>
      </div>
      {children}
    </div>
  );
}

function CardLine({ label, value }) {
  return (
    <div className="flex items-center justify-between rounded-2xl border border-white/70 bg-white/75 px-3 py-2 text-[11px]">
      <span className="text-slate-500">{label}</span>
      <span className="font-semibold text-slate-900">{value}</span>
    </div>
  );
}

function QueueRow({ label, value, tone, width }) {
  return (
    <div>
      <div className="mb-1.5 flex items-center justify-between text-[10px]">
        <span className="font-medium text-slate-600">{label}</span>
        <span className="font-semibold text-slate-900">{value}</span>
      </div>
      <div className="h-2.5 rounded-full bg-white/80">
        <div className={`h-2.5 rounded-full ${tone} ${width}`} />
      </div>
    </div>
  );
}

function FloatingChip({ className, children }) {
  return (
    <div className={`absolute rounded-full border border-white/70 bg-white/65 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.22em] text-sky-700 shadow-[0_16px_30px_-20px_rgba(14,165,233,0.55)] backdrop-blur-sm ${className}`}>
      {children}
    </div>
  );
}

function MobileFlowCard() {
  return (
    <div className="rounded-[28px] border border-white/70 bg-gradient-to-br from-sky-50 via-white to-cyan-50 p-5 shadow-[0_24px_50px_-32px_rgba(15,23,42,0.35)]">
      <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-sky-700">Visío do fluxo</p>
      <div className="mt-4 grid gap-3">
        <div className="flex items-center gap-3 rounded-2xl bg-white/90 p-3">
          <span className="material-symbols-outlined text-sky-700">dataset</span>
          <span className="text-[11px] text-slate-700">Dados entram no estúdio</span>
        </div>
        <div className="flex items-center gap-3 rounded-2xl bg-white/90 p-3">
          <span className="material-symbols-outlined text-sky-700">sell</span>
          <span className="text-[11px] text-slate-700">Etiqueta e layout sío gerados</span>
        </div>
        <div className="flex items-center gap-3 rounded-2xl bg-white/90 p-3">
          <span className="material-symbols-outlined text-sky-700">print</span>
          <span className="text-[11px] text-slate-700">Fila envia para a impressora correta</span>
        </div>
      </div>
    </div>
  );
}
